/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Step {
    COLOR = 'color',
    VERSION = 'version',
    COLOR_VERSION = 'color_version',
    PRINT_OPTION = 'print_option',
    PRINT_OPTION_PER_POSITION = 'print_option_per_position',
    PRODUCTION_SPEED = 'production_speed',
    QUANTITY = 'quantity',
    QUANTITY_PER_COLOR = 'quantity_per_color',
    QUANTITY_PER_SIZE = 'quantity_per_size',
    QUANTITY_PER_SIZE_PER_COLOR = 'quantity_per_size_per_color',
    QUANTITY_PER_VARIANT = 'quantity_per_variant',
}
